import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LandingToolbarComponent } from '../landing-toolbar/landing-toolbar.component';
import { LandingFooterComponent } from '../landing-footer/landing-footer.component';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    LandingToolbarComponent,
    LandingFooterComponent
  ],
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss', '../../../app.component.scss']
})
export class AboutUsComponent {
  mail: string = 'pqrs@workbiservices.com';
  contactMail: string = 'contacto@workbiservices.com';

  services = [
    {
      icon: 'code',
      title: 'Desarrollo de Software a la Medida',
      description: 'Diseño y construcción de aplicaciones web y móviles (iOS y Android) escalables, robustas y adaptadas a los objetivos de tu negocio.'
    },
    {
      icon: 'payments',
      title: 'Integración Fintech y Pasarelas de Pago',
      description: 'Implementación de procesamiento seguro de pagos electrónicos, transacciones en línea e integración con proveedores como ePayco.'
    },
    {
      icon: 'palette',
      title: 'Diseño UX / UI y Prototipado',
      description: 'Creación de interfaces de usuario modernas, funcionales e intuitivas centradas en optimizar la experiencia y retención del usuario.'
    },
    {
      icon: 'cloud_queue',
      title: 'Arquitectura Cloud y Mantenimiento',
      description: 'Despliegue, optimización de infraestructura en la nube y soporte técnico continuo para garantizar alta disponibilidad y seguridad.'
    },
    {
      icon: 'psychology',
      title: 'Consultoría Tecnológica e Innovación',
      description: 'Acompañamiento estratégico en la estructuración de productos digitales, buenas prácticas de desarrollo y transformación digital.'
    }
  ];

  portfolioHighlights = [
    'Emparejamiento inteligente en tiempo real entre demanda y oferta de servicios.',
    'Flujo seguro de transacciones de pago e integración con pasarelas transaccionales.',
    'Módulos integrados de trazabilidad, soporte, calificaciones y reseñas.',
    'Ecosistema móvil respaldado por un panel administrativo web para control operacional.'
  ];
}
